import { connect } from 'react-redux';
import Indicators from './components/Indicators';
import {
  loadUserPreferences,
  updateOrganization,
  updateUserPreferences,
  setCustomIPRangeIndicator,
  setCustomGeoIP,
  loadCustomGeoIP,
  loadCustomGeoIPOrganisation,
  loadCustomDomainIndicators,
  setCustomDomainIndicators,
  deleteCustomDomainIndicators,
  loadCustomIPRangeIndicators,
  setCustomIPRangeIndicators,
  updateCustomIPRangeIndicators,
  deleteCustomIPRangeIndicators,
  loadMySubscriptionPlan,
  loadOrganization,
} from '../../redux/actions/user';
import { loadFilterProfiles } from '../../redux/actions/filters';

const mapStateToProps = (state) => ({
  token: state.auth.token,
  userPreferences: state.user.userPreferences,
  status: state.user.userPreferencesStatus,
  loadCustomDomainIndicatorStatus: state.user.loadCustomDomainIndicatorStatus,
  updateCustomDomainIndicatorStatus:
    state.user.updateCustomDomainIndicatorStatus,
  deleteCustomDomainIndicatorStatus:
    state.user.deleteCustomDomainIndicatorStatus,
  organizationStatus: state.user.status,
  filterStatus: state.filter.profilesLoadStatus,
  organization: state.user.organization,
  customIPRangeIndicators: state.user.customIPRangeIndicators,
  customGeoIPOrganisationUUID: state.user.customGeoIPOrganisationUUID,
  customGeoIpCount: state.user.customGeoIpCount,
  customGeoIPList: state.user.customGeoIPList,
  customOrganizationIPIndicators: state.user.customOrganizationIPIndicators,
  customDomainIndicators: state.user.customDomainIndicators,
  companyDomainIndicators: state.user.companyDomainIndicators,
  brandDomainIndicators: state.user.brandDomainIndicators,
  supplyDomainIndicators: state.user.supplyDomainIndicators,
  mySubscriptionPlan: state.user.mySubscriptionPlan,
  mySubscriptionPlanStatus: state.user.mySubscriptionPlanStatus,
});

const mapDispatchToProps = {
  loadUserPreferences,
  loadFilterProfiles,
  updateUserPreferences,
  updateOrganization,
  setCustomIPRangeIndicator,
  setCustomGeoIP,
  loadCustomGeoIP,
  loadCustomGeoIPOrganisation,
  loadCustomDomainIndicators,
  setCustomDomainIndicators,
  deleteCustomDomainIndicators,
  loadCustomIPRangeIndicators,
  setCustomIPRangeIndicators,
  updateCustomIPRangeIndicators,
  deleteCustomIPRangeIndicators,
  loadMySubscriptionPlan,
  loadOrganization,
};

export default connect(mapStateToProps, mapDispatchToProps)(Indicators);
